import React from 'react';
import { LockIcon, DownloadIcon, FlameIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE } from '../data/offer';
export function PricingSection() {
  return <section id="comprar" className="w-full scroll-mt-16 bg-forest-900 text-cream-100" aria-labelledby="precio-titulo" data-id="element-102" data-mp="1ehp486086rf0">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center lg:py-24" data-id="element-103" data-mp="1jai70oc4vpog">
        <h2 id="precio-titulo" className="font-display text-3xl font-bold sm:text-4xl" data-id="element-104" data-mp="1n9ioo3ivkm9v">
          Una sola consulta veterinaria cuesta muchas veces más que todo el Megapack.
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-cream-200/85" data-id="element-105" data-mp="1x86rhv2agusz">
          Mi misión es que ningún perro sufra por falta de información. Por eso hoy te llevas la
          Guía Maestra y los 5 bonos completos por un único pago.
        </p>

        <div className="mt-10 rounded-3xl border border-forest-700 bg-forest-800 p-8 shadow-2xl sm:p-10" data-id="element-106" data-mp="2x1wff59pqp9">
          <p className="text-sm font-semibold uppercase tracking-[0.16em] text-cream-200/60" data-id="element-107" data-mp="1mgodf7m173ir">
            Acceso completo · pago único
          </p>
          <p className="mt-3 font-display text-6xl font-black text-clay-400 sm:text-7xl" data-id="element-108" data-mp="1hp6dmmvqv8zd">{PRICE}</p>
          <p className="mt-2 text-sm text-cream-200/70" data-id="element-109" data-mp="1crmzdmz1qw7f">
            Guía Maestra + 5 bonos incluidos, sin cobros recurrentes.
          </p>

          <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-alert-500/15 px-4 py-2 text-sm font-semibold text-clay-400" data-id="element-110" data-mp="17pxn64038chr">
            <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-111" data-mp="20g68g4px7d0k" />
            Quedan menos de 100 accesos con 80% de descuento
          </div>

          <div className="mt-8 flex justify-center" data-id="element-112" data-mp="1vfjnwvw3yzrv">
            <CtaButton data-id="element-113" data-mp="1rgj3j8xzfp2r" />
          </div>

          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-cream-200/70" data-id="element-114" data-mp="1rfhvldc9jip9">
            <li className="flex items-center gap-2" data-id="element-115" data-mp="jzuyzyzanqof">
              <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-116" data-mp="fzt5we7mk5kr" /> Pago 100% seguro
            </li>
            <li className="flex items-center gap-2" data-id="element-117" data-mp="hit34zr9ng3t">
              <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-118" data-mp="mgumllslthft" /> Descarga inmediata
            </li>
          </ul>
        </div>
      </div>
    </section>;
}